import { render } from "./TheFinanceTax.vue?vue&type=template&id=f2be0f66&scoped=true&lang=true"
import script from "./TheFinanceTax.vue?vue&type=script&lang=js"
export * from "./TheFinanceTax.vue?vue&type=script&lang=js"

import "./TheFinanceTax.vue?vue&type=style&index=0&id=f2be0f66&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2be0f66"]])

export default __exports__